import { SCREEN_PRESENTER } from '@studio/constants';
import setProgram from './setProgram';
/**
 * Removes a screen share from the program/stage when it's stopped or deleted
 * @param {string} screenShareAttendeeId - The attendee ID of the screen share to remove (e.g., "user-123#content")
 * @returns {Function} Redux thunk function
 */
function removeScreenShareFromProgram(screenShareAttendeeId) {
  return (dispatch, getState) => {
    const { program } = getState();

    if (!program || !program.layers) {
      return;
    }
    // Check if the screen share is currently on stage
    const screenShareLayer = program.layers.find(
      layer =>
        layer.source?.type === SCREEN_PRESENTER &&
        layer.source?.value === screenShareAttendeeId
    );

    if (!screenShareLayer) {
      return;
    }
    const updatedProgram = {
      ...program,
      layers: program.layers.filter(
        layer =>
          !(
            layer.source?.type === SCREEN_PRESENTER &&
            layer.source?.value === screenShareAttendeeId
          )
      )
    };

    dispatch(setProgram(updatedProgram));
  };
}

export default removeScreenShareFromProgram;
